import React from 'react';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { IconButtonProps } from 'components/Icons/constants';
import DownloadSvg from './download.svg';
import cn from './styles.module.scss';

export const DownloadIcon = (props: any) => <Icon component={DownloadSvg} {...props} />;

export const DownloadIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', iconSize = 16, ...props }, ref) => (
    <Button
      ref={ref}
      type={ButtonType.OutlineIcon}
      icon={<DownloadSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
DownloadIconButton.displayName = 'DownloadIconButton';

export const DownloadIconRounded = ({ className, ...props }: any) => (
  <div className={classNames(cn.roundedIcon, className)}>
    <DownloadIcon {...props} />
  </div>
);
